<template>
    <div
        class="flex"
    >
        <div class="filters ml-auto">
            <select
                name="sort"
                @change="(e) => changeItemOrder(e.target.value)"
                class="border rounded bg-white px-3"
                style="height: 34px;"
            >
                <option value="created_at-desc">Sort by newest</option>
                <option value="created_at-asc">Sort by oldest</option>
                <slot name="options"></slot>
            </select>
        </div>

        <div id="query-functions">
            <form
                v-on:submit="handleSearch"
                class="relative"
            >
                <input
                    type="text"
                    class="border rounded pl-2 pr-8 text-gray-800 ml-2"
                    style="height: 34px;"
                    name="text-text"
                    :value="searchText"
                    @input="setSearchInput"
                    placeholder='Search...'
                />
                <button :style="'background-image: url(' + API_URL + '/images/magnifying-glass.png)'"
                        class="search-button">
                    Search
                </button>
            </form>
        </div>
    </div>

</template>
<script>
export default {
    props: {
        changeItemOrder: {
            type: Function,
            required: true,
        },
        handleSearch: {
            type: Function,
            required: true,
        },
        searchText: {
            type: String,
            default: '',
        },
        setSearchInput: {
            type: Function,
            required: true,
        }
    }
}
</script>